import React from 'react';
import Icon from '../../../components/AppIcon';


const TeamIntroduction = ({ currentLanguage }) => {
  const leadershipValues = [
    {
      icon: 'Scale',
      title: currentLanguage === 'en' ? 'Legal Excellence' : 'Ubora wa Kisheria',
      description: currentLanguage === 'en' ?'Committed to delivering the highest standards of legal representation and counsel' :'Kujitolea kutoa viwango vya juu vya uwakilishi na ushauri wa kisheria'
    },
    {
      icon: 'Heart',
      title: currentLanguage === 'en' ? 'Client-Centered Service' : 'Huduma Inayolenga Mteja',
      description: currentLanguage === 'en' ?'Placing client needs and objectives at the center of everything we do' :'Kuweka mahitaji na malengo ya wateja katikati ya kila kitu tunachofanya'
    },
    {
      icon: 'Shield',
      title: currentLanguage === 'en' ? 'Integrity & Trust' : 'Uongozi na Uaminifu',
      description: currentLanguage === 'en' ?'Building lasting relationships through transparency, honesty, and ethical practice' :'Kujenga mahusiano ya kudumu kupitia uwazi, uaminifu, na mazoea ya kimaadili'
    },
    {
      icon: 'Lightbulb',
      title: currentLanguage === 'en' ? 'Innovation & Strategy' : 'Uvumbuzi na Mkakati',
      description: currentLanguage === 'en' ?'Applying creative thinking and strategic planning to complex legal challenges' :'Kutumia mawazo ya ubunifu na mipango ya kimkakati katika changamoto ngumu za kisheria'
    }
  ];

  const firmStats = [
    {
      number: '15+',
      label: currentLanguage === 'en' ? 'Years Combined Experience' : 'Miaka ya Uzoefu wa Pamoja'
    },
    {
      number: '500+',
      label: currentLanguage === 'en' ? 'Cases Successfully Handled' : 'Kesi Zilizoshughulikiwa Kwa Mafanikio'
    },
    {
      number: '98%',
      label: currentLanguage === 'en' ? 'Client Satisfaction Rate' : 'Kiwango cha Kuridhika kwa Wateja'
    },
    {
      number: '24/7',
      label: currentLanguage === 'en' ? 'Client Support Available' : 'Msaada wa Wateja Unapatikana'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg border border-border-light overflow-hidden">
      {/* Hero Section */}
      <div className="relative p-6 lg:p-8 bg-gradient-to-r from-primary/10 via-surface/20 to-accent/10">
        <div className="text-center">
          <h1 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            {currentLanguage === 'en' ? 'Meet Our Leadership Team' : 'Kutana na Timu yetu ya Uongozi'}
          </h1>
          <p className="text-lg text-text-secondary leading-relaxed max-w-4xl mx-auto mb-6">
            {currentLanguage === 'en' ?'Peter & Partners Advocates LLP is led by two distinguished legal professionals who bring together decades of experience, unwavering commitment to client service, and a shared vision for legal excellence. Our leadership team combines deep legal expertise with a client-centered approach that has made us a trusted name in the Kenyan legal landscape.' :'Peter & Partners Advocates LLP inaongozwa na wataalamu wawili wa heshima wa kisheria ambao wanaleta pamoja miongo ya uzoefu, kujitolea kwa huduma za wateja, na maono ya pamoja ya ubora wa kisheria. Timu yetu ya uongozi inachanganya utaalamu wa kina wa kisheria na mbinu inayolenga mteja ambayo imetufanya tuwe jina la kuaminika katika mazingira ya kisheria ya Kenya.'}
          </p>
          
          {/* Firm Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 mt-8">
            {firmStats.map((stat, index) => (
              <div key={index} className="text-center p-4 bg-white/50 rounded-lg border border-border-light">
                <div className="text-2xl lg:text-3xl font-bold text-primary mb-1">
                  {stat.number}
                </div>
                <div className="text-xs lg:text-sm text-text-secondary font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Leadership Philosophy */}
      <div className="p-6 lg:p-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-heading font-bold text-text-primary mb-4">
            {currentLanguage === 'en' ? 'Our Leadership Philosophy' : 'Falsafa yetu ya Uongozi'}
          </h2>
          <p className="text-text-secondary leading-relaxed max-w-3xl mx-auto">
            {currentLanguage === 'en' ?'Our approach to legal practice is built on four fundamental pillars that guide every decision we make and every case we handle. These values reflect our commitment to not just meeting, but exceeding our clients\' expectations while maintaining the highest standards of professional integrity.'
              : 'Mbinu yetu ya mazoea ya kisheria imejengwa juu ya nguzo nne za kimsingi ambazo zinaongoza kila uamuzi tunaoufanya na kila kesi tunayoshughulikia. Maadili haya yanaonyesha kujitolea kwetu si tu kukidhi, bali kuzidi matarajio ya wateja wetu huku tukidumisha viwango vya juu vya uongozi wa kitaalamu.'}
          </p>
        </div>

        {/* Leadership Values */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {leadershipValues.map((value, index) => (
            <div key={index} className="p-6 bg-surface/10 rounded-lg border border-border-light hover:shadow-md transition-shadow duration-200">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                  <Icon name={value.icon} size={24} className="text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-text-primary mb-2">
                    {value.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Team Approach */}
        <div className="bg-gradient-to-r from-surface/20 to-primary/10 rounded-lg p-6 lg:p-8">
          <div className="text-center">
            <h3 className="text-xl lg:text-2xl font-semibold text-text-primary mb-4">
              {currentLanguage === 'en' ? 'Why Choose Our Team?' : 'Kwa Nini Uchague Timu Yetu?'}
            </h3>
            <p className="text-text-secondary leading-relaxed mb-6 max-w-3xl mx-auto">
              {currentLanguage === 'en' ?'When you work with Peter & Partners Advocates LLP, you\'re not just hiring individual lawyers – you\'re gaining access to a collaborative team of legal professionals who work together to ensure the best possible outcomes for your case. Our combined expertise, shared resources, and unified approach mean that you benefit from multiple perspectives and specialized knowledge areas.'
                : 'Unapofanya kazi na Peter & Partners Advocates LLP, si tu kuajiri mawakili binafsi – unapata ufikiaji wa timu ya ushirikiano ya wataalamu wa kisheria ambao wanafanya kazi pamoja kuhakikisha matokeo bora zaidi kwa kesi yako. Utaalamu wetu wa pamoja, rasilimali za pamoja, na mbinu ya umoja inamaanisha unafaidika na mitazamo mingi na maeneo ya utaalamu maalum.'}
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8">
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={20} className="text-primary" />
                <span className="text-sm font-medium text-text-primary">
                  {currentLanguage === 'en' ? 'Collaborative Expertise' : 'Utaalamu wa Ushirikiano'}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={20} className="text-accent" />
                <span className="text-sm font-medium text-text-primary">
                  {currentLanguage === 'en' ? 'Responsive Service' : 'Huduma ya Haraka'}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Award" size={20} className="text-success" />
                <span className="text-sm font-medium text-text-primary">
                  {currentLanguage === 'en' ? 'Proven Results' : 'Matokeo Yaliyothibitishwa'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamIntroduction;